import { StarIcon } from '@phosphor-icons/react'
import React from 'react'

const RatingBar = ({starLabel, reviewCount, percentage}) => {
  
  return (
    <React.Fragment>
      <div className='w-full flex flex-nowrap gap-x-2 items-center justify-center'>
        <StarIcon size={16} weight='fill' />
        <span>{starLabel}</span>
        <div className='flex-1 h-1 bg-gray-200 rounded'>
          <div className='h-full bg-primary rounded' style={{ width: `${percentage}%`}}></div>
        </div>
        <span className='min-w-8 text-[#5D5D5D] text-right'>{reviewCount}</span>
      </div>
    </React.Fragment>
  )
}

export default RatingBar